'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isObject = require('lodash/isObject');var _isObject2 = _interopRequireDefault(_isObject);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _reactInfiniteScroller = require('react-infinite-scroller');var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');
var _ForeignProject = require('../../components/ForeignProject/ForeignProject');var _ForeignProject2 = _interopRequireDefault(_ForeignProject);


var _constants = require('../../constants');
var _checkIsNewProperty = require('../../utils/checkIsNewProperty');
var _modifyImageLink = require('../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _CountryPropertiesList = require('./CountryPropertiesList.scss');var styles = _interopRequireWildcard(_CountryPropertiesList);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
var CountryPropertiesList = function (_Component) {_inherits(CountryPropertiesList, _Component);function CountryPropertiesList() {var _temp, _this, _ret;_classCallCheck(this, CountryPropertiesList);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
















    handleClick = function (evt) {
      var id = (0, _get2.default)(evt, 'currentTarget.dataset.id');
      _this.props.handleClick(evt, id);
    }, _this.

    renderPropertyItem = function (property) {
      var toggleFavorite = function toggleFavorite() {return _this.props.toggleFavorite(property, property.entityType === _constants.ENTITY_TYPES.PROJECT);};
      var isFavorite = _this.props.favoriteProperties.includes(property.id);

      if (property.entityType === _constants.ENTITY_TYPES.PROJECT) {
        return (
          _react2.default.createElement('div', { className: styles.dataProjectWrapper },
            _react2.default.createElement(_ForeignProject2.default, {
              isMobile: _this.props.isMobile,
              openDetailsPopup: _this.props.openDetailsPopup,
              openDetails: _this.openDetails,
              locale: _this.props.locale,
              translate: _this.props.translate,
              isRtl: _this.props.isRtl,
              exactPrice: property.converted_exact_property_price || property.exact_property_price,
              minPrice: property.converted_min_property_price || property.min_property_price,
              images: property.images,
              id: property.id,
              currency: property.target_currency || property.currency,
              name: property.name,
              summary: property.summary,
              address: property.address,
              status: property.status,
              isFavorite: isFavorite,
              toggleFavorite: toggleFavorite })));



      }

      var englishAddressRequired = _constants.localesWithEnglishAddress.includes(_this.props.locale);
      var address = englishAddressRequired ?
      property.address.en :
      property.address[_this.props.locale] || property.address[_constants.language.default];var


      id =













      property.id,thumbnail = property.thumbnail,price = property.price,currency = property.currency,converted_price = property.converted_price,target_currency = property.target_currency,property_type = property.property_type,search_option = property.search_option,created_at = property.created_at,_property$additional_ = property.additional_info;_property$additional_ = _property$additional_ === undefined ? {} : _property$additional_;var rooms = _property$additional_.rooms,parking = _property$additional_.parking,areaObject = _property$additional_.area;

      var isLand = property_type === 'land'; // temp patch
      var floor = isLand ? undefined : (0, _get2.default)(property, 'additional_info.floor.on_the');
      var roomsData = isLand ? undefined : rooms;

      var houseNumber = address.house_number ? ' ' + address.house_number + ',' : '';
      var addressString = address.street_name + ' ' + houseNumber;

      var propertyImage = thumbnail && (0, _modifyImageLink2.default)(thumbnail, _constants.imageModifierTypes.SLIDER_THUMBNAIL) || null;
      var area = (0, _isObject2.default)(areaObject) ? areaObject.base : areaObject; // for migration purposes

      var isNewProperty = created_at ? (0, _checkIsNewProperty.checkIsNewProperty)(created_at, _this.todayDate) : false;

      var CellComponent = _this.props.isMobile ? _components.OMBasePropertyCell : _components.OMBaseForeignCountryCell;
      return (
        _react2.default.createElement('div', { key: id, 'data-id': id, className: styles.countryItem, onClick: _this.handleClick },
          _react2.default.createElement(CellComponent, {
            key: id,
            locale: _this.props.locale,
            isMobile: _this.props.isMobile,
            isRtl: _this.props.isRtl,
            translate: _this.props.translate,
            id: id,
            photo: propertyImage,
            images: property.images,
            price: converted_price || price,
            currency: target_currency || currency,
            address: addressString,
            rooms: roomsData,
            classNameProperty: 'foreignProperties',
            parkingSpots: parking,
            city: address.city_name,
            countryName: address.country_name,
            area: area,
            floor: floor,
            propertyType: _this.props.translate('propertyTypes', property_type)(),
            isFavorite: isFavorite,
            isPromoted: property.is_promoted,
            isTopPromotedProperty: property.is_top_promoted,
            hasVRLink: !!property.vr_link,
            isNewProperty: isNewProperty,
            toggleFavorite: toggleFavorite,
            searchOption: search_option,
            newPropertyLabel: _this.props.translate('iconTitles', 'newPropertyLabel').toString(),
            newPropertyTitle: _this.props.translate('iconTitles', 'newPropertyTitle').toString(),
            groundFloorTitle: _this.props.translate('propertyDetails', 'details', 'groundFloorShortcut') })));



    }, _this.

    renderContent = function () {
      var hasProperties = !!(_this.props.properties && _this.props.properties.length);
      if (!hasProperties && _this.props.propertiesIsLoading && !_this.props.propertysIsLoaded) {
        return (
          _react2.default.createElement('div', { className: styles.spinnerWrapper },
            _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) })));


      }

      if (!_this.props.properties || !_this.props.properties.length) {
        return (
          _react2.default.createElement('div', { className: styles.noResults },
            _react2.default.createElement('h2', null, _this.props.translate('search_box', 'no_results')),
            _react2.default.createElement('div', null, _this.props.translate('search_box', 'change_search_settings'))));


      }

      return hasProperties &&
      _react2.default.createElement(_reactInfiniteScroller2.default, {
          className: styles.row,
          loadMore: _this.props.loadMore,
          hasMore: _this.props.hasMore,
          loader: _react2.default.createElement('div', { className: 'loader', key: 0 }, 'Loading ...') },

        _this.props.properties.map(_this.renderPropertyItem));


    }, _temp), _possibleConstructorReturn(_this, _ret);}CountryPropertiesList.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps) {var isMobileChanged = newProps.isMobile !== this.props.isMobile;var isLocaleChanged = newProps.locale !== this.props.locale;var isLoadingProperties = newProps.propertiesIsLoading !== this.props.propertiesIsLoading;var isLoaded = newProps.propertysIsLoaded !== this.props.propertysIsLoaded;var isPropertiesChanged = !(0, _isEqual2.default)(newProps.properties, this.props.properties);var isFavoritePropertiesChanged = !(0, _isEqual2.default)(newProps.favoriteProperties, this.props.favoriteProperties);return isMobileChanged || isLocaleChanged || isPropertiesChanged || isFavoritePropertiesChanged || isLoadingProperties || isLoaded;};CountryPropertiesList.prototype.

  render = function render() {var _this2 = this;
    return (
      _react2.default.createElement('div', { className: styles.wrapper, ref: function ref(_ref) {_this2.containerRef = _ref;} },
        this.renderContent()));


  };return CountryPropertiesList;}(_react.Component);


CountryPropertiesList.propTypes = {
  properties: _propTypes2.default.array,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  hasMore: _propTypes2.default.bool,
  loadMore: _propTypes2.default.func,
  handleClick: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  favoriteProperties: _propTypes2.default.array,
  isProjects: _propTypes2.default.bool,
  propertiesIsLoading: _propTypes2.default.bool,
  propertysIsLoaded: _propTypes2.default.bool };exports.default =


CountryPropertiesList;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CountryPropertiesList/CountryPropertiesList.js
// module id = 2631
// module chunks = 0